/**
 * Testing, test environments and test credentials.
 *
 * Two rules shape every type here. A test account's password never appears in a list or detail
 * response — only `reveal` returns it, once, against a live grant. And a UAT assignment is the
 * only kind a client may see, so nothing on the client-facing shapes carries a staging URL, a
 * pull request, a credential or another client's work.
 */
export const TESTER_VIEW = {
    MINE: 'mine',
    READY: 'ready',
    TODAY: 'today',
    FAILED: 'failed',
    RETEST: 'retest',
    PASSED_TODAY: 'passed_today',
    UAT: 'uat',
    LIVE: 'live',
    OVERDUE: 'overdue',
};
export const TEST_SEVERITY = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    CRITICAL: 'CRITICAL',
};
export const CREDENTIAL_ROTATION_POLICY = {
    AFTER_TEST: 'AFTER_TEST',
    DAILY: 'DAILY',
    MANUAL: 'MANUAL',
};
export const CREDENTIAL_ACTION = {
    GENERATE: 'GENERATE',
    REVEAL: 'REVEAL',
    ROTATE: 'ROTATE',
    REVOKE: 'REVOKE',
};
export const TEST_ENVIRONMENT_STATUS = {
    UP: 'UP',
    DOWN: 'DOWN',
    DEPLOYING: 'DEPLOYING',
    UNKNOWN: 'UNKNOWN',
};
export const UAT_DECISION = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    CHANGES_REQUESTED: 'CHANGES_REQUESTED',
};
//# sourceMappingURL=qa.js.map